import { render, staticRenderFns } from "./UserGuideSearchResultsList.vue?vue&type=template&id=5da816bc&scoped=true"
import script from "./UserGuideSearchResultsList.vue?vue&type=script&lang=js"
export * from "./UserGuideSearchResultsList.vue?vue&type=script&lang=js"
import style0 from "./UserGuideSearchResultsList.vue?vue&type=style&index=0&id=5da816bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da816bc",
  null
  
)

export default component.exports